import { render, staticRenderFns } from "./SponsoredRecommendationModule.vue?vue&type=template&id=4654e802&scoped=true"
import script from "./SponsoredRecommendationModule.vue?vue&type=script&setup=true&lang=ts"
export * from "./SponsoredRecommendationModule.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SponsoredRecommendationModule.vue?vue&type=style&index=0&id=4654e802&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4654e802",
  null
  
)

export default component.exports